function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Union 7",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 58c-6.172 0-11.96-.803-16.299-2.26-3.883-1.305-6.201-3.037-6.201-4.635V10h45v41.105c0 1.598-2.318 3.33-6.201 4.635-4.34 1.457-10.127 2.26-16.3 2.26z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 57c6.066 0 11.741-.784 15.98-2.208 1.91-.642 3.442-1.396 4.43-2.18.692-.55 1.09-1.1 1.09-1.507V11h-43v40.105c0 .407.398.957 1.09 1.507.988.784 2.52 1.538 4.43 2.18C20.258 56.216 25.934 57 32 57m0 2c-12.98 0-23.5-3.534-23.5-7.895V9h47v42.105C55.5 55.465 44.979 59 32 59z",
  fill: "#5dbeff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Union 8",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5 29.69V9h47v20.69C55.5 34.832 44.979 39 32 39S8.5 34.832 8.5 29.69z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 38c6.155 0 11.925-.943 16.249-2.656 3.973-1.574 6.251-3.635 6.251-5.654V10h-45v19.69c0 2.02 2.278 4.08 6.251 5.654C20.075 37.057 25.846 38 32.001 38m0 1C19.02 39 8.5 34.832 8.5 29.69V9h47v20.69C55.5 34.832 44.98 39 32 39z",
  fill: "#5dbeff"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 112",
  transform: "translate(8.5)",
  fill: "#fff",
  stroke: "#5dbeff"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.5,
  cy: 9.5,
  rx: 23.5,
  ry: 9.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.5,
  cy: 9.5,
  rx: 23,
  ry: 9,
  fill: "none"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 8",
  fill: "none",
  stroke: "#5dbeff",
  d: "M0 72.5h65"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 9",
  fill: "none",
  stroke: "#5dbeff",
  d: "M33 62.5v10"
});

var SvgDatabase = function SvgDatabase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 73",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDatabase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/database.97b3b06f.svg";
export { ForwardRef as ReactComponent };